module.exports = __webpack_public_path__ + "img/direct_debit_icon.5a675642.png";